// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucidePencil as RawLucidePencil } from "lucide-react";
export const LucidePencil = /* @__PURE__ */ createIcon(RawLucidePencil, "LucidePencil", 2);
